import React from "react";

function Interests() {
  return (
    <div className="interests">
      <h2>_Interests</h2>
      <p> A list of the technologies & languages i hope to waddle into in the nearest future: </p>
      <ol>
        <li>Python</li>
        <li>Graph Ql</li>
        <li>Three Js</li>
        <li>UX Design</li>
        <li>Java</li>
        <li>Unity</li>
        <li>Blender</li>
        <li>Web 3</li>
      </ol>
    </div>
  );
}

export default Interests;
